export default {
  setGenderChoices(state, payload) {
    state.genderChoices = payload;
  },
};
